import { ThemeProvider, theme } from '@primer/react';

import deepmerge from 'deepmerge';
import 'react-loading-skeleton/dist/skeleton.css';
import { BrowserRouter as Router } from 'react-router-dom';
import BaseStyles from './BaseStyles';
import { LazyPage } from './components-ui/loadable';
import { CommonProvider } from './contexts/common';
const AuthorizedContent = LazyPage(import("./content/AuthorizedContent"))

const customTheme = deepmerge({
  ...theme,
  fontSizes: ['11px', '13px', '16px', '20px', '24px', '32px', '40px', '48px', '56px'],
  radii: ["4px", "6px", "8px"]
},
  {

    colorSchemes: {
      light: {
        colors: {
          accent: {
            fg: "#0969da",
            emphasis: "#0969da"
          },
          btn: {
            bg: "#fff",
            primary: {
              bg: "#0969da",
              focusBg: "#0969da",
              hoverBg: "#0969da",
              selectedBg: "#0969da",
              disabledBg: "rgba(84, 174, 255, 0.4)"
            },
          },
          primer: {
            border: {
              active: "#0969da"
            }
          }

        }
      }
    }
  })

function App() {

  return (
    <Router>
      <CommonProvider>
        <ThemeProvider theme={customTheme} colorMode={"light"}>
          <BaseStyles>
           
              <AuthorizedContent />
           
          </BaseStyles>
        </ThemeProvider>
      </CommonProvider>
    </Router>
  );
}
export default App;
